/* eslint-disable array-callback-return */
import { BreadcrumbManager as HeadlessBreadcrumbManager } from '@coveo/headless';
import $ from 'jquery';
import React, { Dispatch, FunctionComponent, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setActiveClearValueInputPrice } from '../../../../actions/searchBoxAction';
import { pillName } from '../../../../utils/utils';
import '../scss/Breadcrumbs.scss';
import {facetCommonCategoryfilter} from "../../../../controllers/facetControllers";

interface BreadcrumbManagerProps {
  controller: HeadlessBreadcrumbManager;
  listFacetDeSelectAll: any;
  controllerFacetPill: any;
  typeFacet: any;
  isAffiliate?: boolean;
  setIsActiveOKB?: Dispatch<React.SetStateAction<boolean>>;
  setIsActiveProductType?: Dispatch<React.SetStateAction<boolean>>;
  setIsActiveType?: Dispatch<React.SetStateAction<boolean>>;
  setIsActiveSalesforce?: Dispatch<React.SetStateAction<boolean>>;
  isOffsetTop: boolean;
  currentCategoryFacet?: any;
}

let BreadcrumbManager: FunctionComponent<BreadcrumbManagerProps> = (
  props
) => {
  const { controller } = props;
  const [state, setState] = useState(controller.state);
  const {isAffiliate} = props;
  const dispatch = useDispatch();
  let exitDateFacets: string[] = [];
  useEffect(() => controller.subscribe(() => setState(controller.state)), [controller]);

  function clearAllFacet() {
    if(isAffiliate){
      const startPriceEle = document.getElementById("startPriceAffiliate") as HTMLInputElement;
      const endPriceEle = document.getElementById("endPriceAffiliate") as HTMLInputElement;
      if(startPriceEle){
        startPriceEle.value = '';
      } if (endPriceEle){
        endPriceEle.value =''
      }
    }
    else{
      const startPriceEle = document.getElementById("startPrice") as HTMLInputElement;
      const endPriceEle = document.getElementById("endPrice") as HTMLInputElement;
      if(startPriceEle?.value || endPriceEle?.value){
        dispatch(setActiveClearValueInputPrice({value : true}))
      } 
    }
    const startDateEle = document.getElementById("startDate") as HTMLInputElement;
    const endDateEle = document.getElementById("endDate") as HTMLInputElement;
    if(startDateEle){
      startDateEle.value = '';
    } if (endDateEle){
      endDateEle.value =''
    }
    // close list child category facets
    if(props.setIsActiveSalesforce){
      props.setIsActiveSalesforce(false);
    }
    else if(props.setIsActiveProductType){
      props.setIsActiveProductType(false);
    }
    else if(props.setIsActiveType){
      props.setIsActiveType(false);
    }
    props.controller.deselectAll();
    if (props.currentCategoryFacet) {
      // @ts-ignore
      facetCommonCategoryfilter.toggleSelect(props.currentCategoryFacet);
    }

  }

  function renderButtonClear() {
    let isButtonClear = false;
    state.facetBreadcrumbs.forEach(facetBreadcrumb => {
      const matchFacetSelected = facetBreadcrumb.values.find(value => value.value.value !== pillName.PRODUCT && value.value.value !== pillName.INDUSTRIES && value.value.value !== pillName.INSPIRATION && value.value.value !== pillName.LEARNING && value.value.value !== pillName.RESOURCES && value.value.value !== pillName.SUPPORT);
      if (matchFacetSelected) {
        isButtonClear = true;
      }
    });
    state.numericFacetBreadcrumbs.forEach(facetBreadcrumb => {
      const matchFacetSelected = facetBreadcrumb.values.find(value => value.value.state === 'selected' && (facetBreadcrumb.field === 'aem_price' || facetBreadcrumb.field === 'final_price'));
      if (matchFacetSelected) {
        isButtonClear = true;
      }
    });
    state.dateFacetBreadcrumbs.forEach(facetBreadcrumb => {
      const matchFacetSelected = facetBreadcrumb.values.find(value => value.value.state === 'selected' && (facetBreadcrumb.field === 'aem_startdate' || facetBreadcrumb.field === 'aem_enddate'));
      if (matchFacetSelected) {

        isButtonClear = true;
      }
    });
    if (isButtonClear) {
      return (
        <button onClick={() => clearAllFacet()} className="clearBreadcrumbs-btn">Clear All</button>
      );
    }
    return '';

  }

  // reset datepicker when deselect date range
  const dateDeselect = (breadcrumb: any) => {
    // breadcrumb.deselect();
    state.dateFacetBreadcrumbs.map(value => {
      value.values.map(breadcrumb => {
        breadcrumb.deselect()
      })
    })
    $('.datepicker').datepicker('setDate', null);
  };
  const formatNumberWithCommas = (number :any) => {
    return Number(number.toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  const comparePrice = (breadcrumb: any, isInputBreadcrumb = false) => {
    const startPriceId = isAffiliate ? 'startPriceAffiliate' : 'startPrice';
    const endPriceId = isAffiliate ? 'endPriceAffiliate' : 'endPrice';
    const startPriceEle = document.getElementById(startPriceId) as HTMLInputElement;
    const endPriceEle = document.getElementById(endPriceId) as HTMLInputElement;
    const inputBreadcrumbEle = document.querySelector(".facet-btn.input-facet") as HTMLInputElement;
    const filterSectionEl = document.querySelector('.breadcrumb-header');
    const startValue = filterSectionEl?.getAttribute('startPrice');
    const endPrice = filterSectionEl?.getAttribute('endPrice');

    if (breadcrumb.value.numberOfResults > 0) {
      let startPrice : any = "$" + formatNumberWithCommas(breadcrumb.value.start) + " - ";
      let endPrice : any = "$" + formatNumberWithCommas(breadcrumb.value.end);
      if (startPrice == "$0 - ") {
        startPrice = "Under ";
      }
      if (isInputBreadcrumb) {
        startPrice = "$" + startPriceEle?.value.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " - ";
        endPrice = "$" + endPriceEle?.value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        if (startPrice == "$0 - ") {
          startPrice = "Under ";
        }
        if (startPrice == "$ - ") {
          startPrice = "min. - ";
        }
        if (endPrice == "$") {
          endPrice = "max.";
        }
      }
      return <div>Price: {startPrice}{endPrice}</div>
    }
  };

  return (
    <div className={props.isOffsetTop ? "breadcrumb-section offset-top" : "breadcrumb-section"}>
      {
          (
              (
                  (state.dateFacetBreadcrumbs.length > 0 || state.numericFacetBreadcrumbs.length > 0 || state.facetBreadcrumbs.length) > 0 && props.isOffsetTop
              ) || !props.isOffsetTop
          ) && <div className="breadcrumb-header"><p>Filters</p>{renderButtonClear()}</div>
      }
      <ul className="selected-filters">
        {state.facetBreadcrumbs.map((facet) => (
          <li key={facet.facetId}>
            {' '}
            {facet.values.map((breadcrumb) => {
              if (breadcrumb.value.value !== (pillName.PRODUCT) &&
                breadcrumb.value.value !== pillName.RESOURCES &&
                breadcrumb.value.value !== pillName.SUPPORT &&
                breadcrumb.value.value !== pillName.INDUSTRIES &&
                breadcrumb.value.value !== pillName.INSPIRATION &&
                breadcrumb.value.value !== pillName.LEARNING &&
                  breadcrumb.value.value !== pillName.COMMUNITY
              )
                return (
                  <button
                    className="facet-btn"
                    key={breadcrumb.value.value}
                    onClick={() => breadcrumb.deselect()}
                  >
                    {facet.facetId === "FileTypeRecommended" ? "Recommended" : breadcrumb.value.value}
                  </button>
                );
              return '';
            })}
          </li>
        ))}
        {
        state.numericFacetBreadcrumbs.map((facet,index) => {
          const startPriceId = isAffiliate ? 'startPriceAffiliate' : 'startPrice';
          const endPriceId = isAffiliate ? 'endPriceAffiliate' : 'endPrice';
          const startPriceEle = document.getElementById(startPriceId) as HTMLInputElement;
          const endPriceEle = document.getElementById(endPriceId) as HTMLInputElement;
          let className = "facet-btn input-facet";
          let startPriceConvert : any, endPriceConvert : any;
          if (startPriceEle == null && endPriceEle == null) {
            startPriceConvert = 0;
            endPriceConvert = 0;
          } else {
            startPriceConvert = startPriceEle.value;
            endPriceConvert = endPriceEle.value;
            if (startPriceConvert == "0") {
              startPriceConvert = "0";
            }
            if (startPriceConvert == "") {
              startPriceConvert = "-1";
            }
            if (endPriceConvert == "") {
              let valueMax = facet.values.reduce((max : any, next: any) => {
                return next.end > max.end ? next : max;
              });
              endPriceConvert = valueMax.value.end;
            }
          }
          return (
              <li key={facet.facetId + index}>
                {' '}
                {facet.values.map((breadcrumb) => {
                  if (breadcrumb.value.numberOfResults <= 0) {
                    return;
                  }
                  let isInputBreadcrumb = false;
                  let className = "facet-btn ";
                  if (Number(startPriceConvert) == breadcrumb.value.start && Number(endPriceConvert) == breadcrumb.value.end) {
                    isInputBreadcrumb = true;
                    className += "input-facet";
                  }

                  return (
                      <button
                          className={className} id="price-clear-btn"
                          key={breadcrumb.value.numberOfResults}
                          onClick={(e) => {
                            breadcrumb.deselect()
                            if (e.currentTarget.classList.contains("input-facet")) {
                            dispatch(setActiveClearValueInputPrice({value: true}))
                            }
                          }}
                      >
                        {comparePrice(breadcrumb, isInputBreadcrumb)}
                      </button>
                  );
                })}
              </li>
          )
        })}
        {state.dateFacetBreadcrumbs.map((facet) => {
          if (facet.field !== 'aem_startdate' && !exitDateFacets.includes(facet.field)) {
              exitDateFacets.push(facet.field);
            return (<li key={facet.facetId}>
              {facet.values.map((breadcrumb) => {
                const valueStartDate = breadcrumb.value.start.split('@')[0];
                const valueEndDate = breadcrumb.value.end.split('@')[0];
                const reverseValueStartDate = valueStartDate.split('/')[1] + "/" + valueStartDate.split('/')[2] + "/" + valueStartDate.split('/')[0];
                const reverseValueEndDate = valueEndDate.split('/')[1] + "/" + valueEndDate.split('/')[2] + "/" + valueEndDate.split('/')[0];
                return (
                  <button
                    className="facet-btn" id="date-clear-btn"
                    key={breadcrumb.value.numberOfResults}
                    onClick={() => dateDeselect(breadcrumb)}
                  >
                    {reverseValueStartDate} - {reverseValueEndDate}
                  </button>
                );
              })}
            </li>);
          }
          return '';

        })}
      </ul>
    </div>
  );
};

export default BreadcrumbManager;